import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useSearchParams } from 'react-router-dom';
import DashboardPage from '../pages/DashboardPage';
import LoginPage from '../pages/Welcome/LoginPage';
import OpenFiLandingPage from '../pages/Welcome/OpenFiLandingPage';
import ProfileSwitchPage from '../pages/Welcome/ProfileSwitchPage';
import ProtectedRoute from './ProtectedRoute';
import SignupPage from '../pages/Welcome/SignupPage';
import NewProfilePage from '../pages/Welcome/NewProfilePage';
import SettingsPage from '../pages/Config/SettingsPage';
import UserMgtPage from '../pages/Config/UserMgtPage';
import CollectionWalletPage from '../pages/Config/CollectionWalletPage';
import WifiPlanCreatePage from '../pages/Config/wifi/WifiPlanCreatePage';
import WifiPlanPage from '../pages/Config/wifi/WifiPlanPage';
import WifiPlanEditPage from '../pages/Config/wifi/WifiPlanEditPage';
import RoutersPage from '../pages/Config/router/RoutersPage';
import NewRouterPage from '../pages/Config/router/NewRouterPage';
import RouterEditPage from '../pages/Config/router/RouterEditPage';
import VoucherMgtPage from '../pages/VoucherMgtPage';
import NotFoundPage from '../pages/Welcome/NotFoundPage';
import ResetPasswordPage from '../pages/Welcome/ResetPasswordPage';
import MobileMoneyPage from '../pages/MobileMoneyPage';
import WifiPlansPage from '../pages/WifiPlansPage';
import CustomersPage from '../pages/CustomersPage';
import DeviceHistoryPage from '../pages/Voucher/DeviceHistoryPage';
import VoucherUsagePage from '../pages/Voucher/VoucherUsagePage';
import SalesReportPage from '../pages/SalesReportPage';
import LicensePage from '../pages/LicensePage';
import VendorPage from '../pages/Vendor/VendorPage';
import { useAuth } from '../DataStore/AuthContext';
import VendorVouchers from '../pages/Vendor/VendorVouchers';
import SalesAgentPage from '../pages/Vendor/SalesAgentPage';
import ForgotPasswordPage from '../pages/Welcome/ForgotPasswordPage';

const SystemRoutes = () => {

  const {user} = useAuth();
    // This component handles ?challenge=value logic
const ChallengeHandler = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const challengeValue = searchParams.get('challenge');
    if (challengeValue) {
      localStorage.setItem('ofc', challengeValue);
    }
    navigate('/'); // Redirect to dashboard
  }, [navigate, searchParams]);

  return null; // No UI needed
};

    return (
        <Router>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/welcome" element={<OpenFiLandingPage />} />
              <Route path="/forgot-password" exact element={<ForgotPasswordPage />} />
              <Route path="/password-reset" exact element={<ResetPasswordPage />} />
              <Route path="/auth" element={<ChallengeHandler />} />
              <Route path="/switch" element={<ProfileSwitchPage />} />
              <Route path="/profile-create" element={<NewProfilePage />} />
              <Route path="/" element={<LoginPage />} />
              {user?.role?.role_name === 'Billing' && (<>
              <Route path="/dashboard" element={<ProtectedRoute element={VendorPage} />} />
              <Route path="/vouchers" element={<ProtectedRoute element={VendorVouchers} />} />
              </>)}

              {user?.role?.role_name !== 'Billing' && (<>
              <Route path="/dashboard" element={<ProtectedRoute element={DashboardPage} />} />
              </>)}
              {user?.role?.is_admin === true && (<>
              <Route path="/settings" element={<ProtectedRoute element={SettingsPage} />} />
              <Route path="/settings/users" element={<ProtectedRoute element={UserMgtPage} />} />
              <Route path="/settings/wallet" element={<ProtectedRoute element={CollectionWalletPage} />} />
              <Route path="/settings/plans" element={<ProtectedRoute element={WifiPlanPage} />} />
              <Route path="/settings/plans-new" element={<ProtectedRoute element={WifiPlanCreatePage} />} />
              <Route path="/settings/plans-edit" element={<ProtectedRoute element={WifiPlanEditPage} />} />
              <Route path="/settings/routers" element={<ProtectedRoute element={RoutersPage} />} />
              <Route path="/settings/routers-new" element={<ProtectedRoute element={NewRouterPage} />} />
              <Route path="/settings/routers-edit" element={<ProtectedRoute element={RouterEditPage} />} />
              </>)}


              {user?.role?.role_name !== 'Billing' && (<>
              <Route path="/voucher-mgt" element={<ProtectedRoute element={VoucherMgtPage} />} />
              <Route path="/voucher-usage" element={<ProtectedRoute element={VoucherUsagePage} />} />
              <Route path="/mobile-money" element={<ProtectedRoute element={MobileMoneyPage} />} />
              <Route path="/wifi-plans" element={<ProtectedRoute element={WifiPlansPage} />} />
              <Route path="/network-users" element={<ProtectedRoute element={CustomersPage} />} />
              <Route path="/network-device" element={<ProtectedRoute element={DeviceHistoryPage} />} />
              <Route path="/sales-report" element={<ProtectedRoute element={SalesReportPage} />} />
              <Route path="/sales-agents" element={<ProtectedRoute element={SalesAgentPage} />} />
              <Route path="/license" element={<ProtectedRoute element={LicensePage} />} />
              </>)}

              <Route path="*" exact element={<NotFoundPage/>} />

            </Routes>
        </Router>
    );
};

export default SystemRoutes;